// Spread for button has type

import { Layout } from "antd";
import { Outlet } from "react-router";
import Footer from "./Footer";
import "./styles.css";

import { useBetaSurveyFeatureFlag } from "@/utils/featureFlags";
import BetaSurvey from "../BetaSurvey";
import ErrorHandler from "../ErrorHandler";
import FloatMenu from "../FloatMenu";
import Header from "./Header";

function ScreenLayout() {
    const { isEnabled } = useBetaSurveyFeatureFlag();

    return (
        <Layout className="screen-layout">
            <Header />
            <Layout.Content className="site-content">
                <ErrorHandler>
                    <Outlet />
                </ErrorHandler>
                <FloatMenu />
            </Layout.Content>
            <Footer />
            {isEnabled && <BetaSurvey />}
        </Layout>
    );
}

export default ScreenLayout;
